(function($, Drupal, debounce) {
  'use strict';

  Drupal.behaviors.newsletter_popup = {
    attach: function (context) {

      $(window).on('load resize', function () {
        var newsletter_modal = $('.block-newsletter-modal');
        if ($(newsletter_modal).css('display') != 'none') {
          $(newsletter_modal).addClass('show');
          toggleNewsletterFields();
        }
      }).trigger('resize');

      $('.block-newsletter-modal .spb_close').click(function() {
        var newsletter_modal = $('.block-newsletter-modal');
        if ($(newsletter_modal).hasClass('show')) {
          $(newsletter_modal).removeClass('show');
        }
      });

      $(function() {
        var newsletter_modal = $('.block-newsletter-modal');
        // WCAG
        if ($(newsletter_modal).hasClass('show')) {
          // Set first input element to have focus
          $(newsletter_modal).find('input').first().focus();

          // Make Simple Popup Close button focusable
          $(newsletter_modal).find('.spb_close').attr('tabindex', '-1');

          $('.spb_close').keydown(function (e) {
            if (e.key === 'Enter' | e.key === ' ') {
              $(this).click();
            }
          });
          trapFocusWithinModal(newsletter_modal);
        }
      });

      function trapFocusWithinModal(modalElement) {
        // Focusable element variables for mobile menu
        var focusableEls = $(modalElement).find('input[type=text]:not([disabled], [name=url]), input[type=submit], .js-form-item a, .spb_close');
        var firstFocusableEl = focusableEls[0];
        var lastFocusableEl = focusableEls[focusableEls.length - 1];

        // Trap focus within the mobile menu modal
        $(focusableEls).keydown(function (e) {
          if (e.key === 'Tab') {
            if (e.shiftKey) /* shift + tab */ {
              if (document.activeElement === firstFocusableEl) {
                lastFocusableEl.focus();
                e.preventDefault();
              }
            }
            else /* tab */ {
              if (document.activeElement === lastFocusableEl) {
                firstFocusableEl.focus();
                e.preventDefault();
              }
            }
          }
        });
      }

      function toggleNewsletterFields() {
        var is_role_hidden = $('.block-newsletter-modal .field--name-field-is-role-hidden').text();
        var is_role_hidden_form_field = $('form.webform-submission-newsletter-form input[name="is_role_hidden"]');
        if(is_role_hidden == 1) {
          is_role_hidden_form_field.val("1").trigger('change');
        }
        else if(is_role_hidden == 0) {
          is_role_hidden_form_field.val("0").trigger('change');
        }
      }
    }
  };
})(jQuery, window.Drupal, Drupal.debounce);
  